"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.setSelectedItem = exports.setIsEdited = exports.setFileEdited = exports.setFile = exports.setErrors = exports.itemReducer = exports.defaultConsumable = exports.defaultBadgeSettings = exports.clearState = void 0;
var toolkit_1 = require("@reduxjs/toolkit");
var defaultBadgeSettings = {
    sub_copy: "",
    theme: {
        primary: "#d2a023",
        name: "#1f2937",
        sub_copy: "#000000",
        background: "#FFFFFF",
        icon: "#FFFFFF",
    },
};
exports.defaultBadgeSettings = defaultBadgeSettings;
var defaultConsumable = { enabled: false, uses_per_unit: 1, expires_after_days: null };
exports.defaultConsumable = defaultConsumable;
var initialState = {
    selectedItem: {
        type: "badge",
        name: "",
        description: "",
        icon: { name: "", url: "", etag: "" },
        dates_enabled: false,
        start_date: null,
        end_date: null,
        quantity_limited: false,
        quantity: 0,
        stackable: true,
        consumable: defaultConsumable,
        badge: defaultBadgeSettings,
    },
    file: null,
    isEdited: false,
    isFileEdited: false,
    errors: {},
};
var slice = (0, toolkit_1.createSlice)({
    name: "itemState",
    initialState: initialState,
    reducers: {
        setSelectedItem: function (state, action) {
            state.selectedItem = action.payload;
        },
        clearState: function () { return initialState; },
        setIsEdited: function (state, action) {
            state.isEdited = action.payload;
        },
        setFileEdited: function (state, action) {
            state.isFileEdited = action.payload;
        },
        setFile: function (state, action) {
            state.file = action.payload;
        },
        setErrors: function (state, action) {
            state.errors = action.payload;
        },
    },
});
var _a = slice.actions, setSelectedItem = _a.setSelectedItem, clearState = _a.clearState, setIsEdited = _a.setIsEdited, setFileEdited = _a.setFileEdited, setFile = _a.setFile, setErrors = _a.setErrors;
exports.setSelectedItem = setSelectedItem;
exports.clearState = clearState;
exports.setIsEdited = setIsEdited;
exports.setFileEdited = setFileEdited;
exports.setFile = setFile;
exports.setErrors = setErrors;
var itemReducer = slice.reducer;
exports.itemReducer = itemReducer;
